/** The stand-in career's numbers: `src/data/reach-standin.json`, Zod-validated here (M3 plan R5). */
import { z } from 'zod'
import standinJson from '../../data/reach-standin.json'

const perPart = <T extends z.ZodType>(v: T) => z.strictObject({ hull_plating: v, electronics: v, drive_parts: v })
const price = z.number().int().nonnegative()

export const standInConfigSchema = z.strictObject({
  comment: z.string().optional(),
  startCredits: z.number().int().nonnegative(),
  capacityT: z.number().positive(),
  partMassT: perPart(z.number().positive()),
  partPrices: perPart(price),
  scannerPrices: z.strictObject({ '2': price, '3': price }),
  deathLosesParts: z.boolean(),
})

export type StandInConfig = z.infer<typeof standInConfigSchema>

/** Parses and validates reach-standin.json (throws a ZodError naming the bad field). */
export function loadStandInConfig(raw: unknown = standinJson): StandInConfig {
  return standInConfigSchema.parse(raw)
}
